import { cn } from '@/utils/cn'
import type { ReactNode } from 'react'

interface Props {
  isLoading?: boolean
  label: ReactNode
  value: ReactNode
  className?: string
  labelClassName?: string
  valueClassName?: string
}

export const DefinitionStat = ({ isLoading, label, value, className, labelClassName, valueClassName }: Props) => (
  <div className={cn('flex min-w-0 flex-col', className)}>
    <dt className={cn('font-medium text-caption-foreground text-xs', labelClassName)}>{label}</dt>
    <dd className={cn('font-medium text-2xl text-heading-foreground', isLoading && 'animate-pulse', valueClassName)}>
      {value}
    </dd>
  </div>
)
